import { render, staticRenderFns } from "./RankChartsRate.vue?vue&type=template&id=5aabe4f8&scoped=true"
import script from "./RankChartsRate.vue?vue&type=script&lang=js"
export * from "./RankChartsRate.vue?vue&type=script&lang=js"
import style0 from "./RankChartsRate.vue?vue&type=style&index=0&id=5aabe4f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aabe4f8",
  null
  
)

export default component.exports